import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import inventoryObjects from "../../../clients/inventoryObjects";

const SearchByToggle = ({ searchType, handleSearchTypeChange }) => {
  // a pill inside a pill: the group is the outlined track, the selected button is the filled thumb.
  // MUI gives grouped buttons square inner corners and divider borders, so those get overridden here.
  const segmentStyle = {
    border: "none !important",
    borderRadius: "100px !important",
    margin: 0,
    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 3,
    paddingRight: 3,
    color: (theme) => theme.palette.terrain[900],
    "&:hover": {
      backgroundColor: (theme) => theme.palette.terrain[200],
    },
    "&.Mui-selected, &.Mui-selected:hover": {
      color: (theme) => theme.palette.pure.white,
      backgroundColor: (theme) => theme.palette.terrain[900],
    },
  };

  // ToggleButtonGroup hands back null when the selected button is clicked again. Searching has to
  // happen against something, so we ignore that and keep the current mode selected.
  const handleChange = (_, newSearchType) => {
    if (!newSearchType) {
      return;
    }

    handleSearchTypeChange(newSearchType);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{ fontWeight: 700, marginRight: 2, whiteSpace: "nowrap" }}
      >
        Search by:
      </Typography>
      <ToggleButtonGroup
        value={searchType}
        onChange={handleChange}
        size="small"
        exclusive
        sx={{
          backgroundColor: (theme) => theme.palette.pure.white,
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          borderRadius: "100px",
          padding: 0.5,
          "& .MuiToggleButtonGroup-grouped": segmentStyle,
        }}
      >
        <ToggleButton value={inventoryObjects.recipeSearchTypes.name}>
          <Typography
            variant="body1"
            sx={{ textTransform: "none", fontWeight: 600, whiteSpace: "nowrap" }}
          >
            Recipe Name
          </Typography>
        </ToggleButton>
        <ToggleButton value={inventoryObjects.recipeSearchTypes.ingredient}>
          <Typography
            variant="body1"
            sx={{ textTransform: "none", fontWeight: 600, whiteSpace: "nowrap" }}
          >
            Ingredient Name
          </Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SearchByToggle;
